import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedChronReference } from './schemas'

export type MedChronReferencesRecord = { [reference_id: string]: MedChronReference }

export type MedChronReferencesState = {
  references: { [job_id: string]: MedChronReferencesRecord }
}

const initialState: MedChronReferencesState = {
  references: {},
}

export const medChronReferencesSlice = createSlice({
  name: 'medChronReferencesState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setJobReferencesRecord: (state, action: PayloadAction<{ medChronJobId: string; references: MedChronReferencesRecord }>) => {
      state.references[action.payload.medChronJobId] = action.payload.references
    },
  },
})

// Actions
export const MedChronReferencesActions = medChronReferencesSlice.actions

export default medChronReferencesSlice.reducer
